import React, { useState } from 'react';
import "./PlateWell.css";
import { useDropDownSelectedData } from '../../store/plateWellStore';
import { useChannels, useShowGraph } from "../../store/plateWellStore"
import { cssClassForChannel } from "../../utils/basic";
import useFetch96WellPlate2Dgraph from "../Hooks/qlp_ddpcr/useFetchQlp96WellPlate2Dgraph"
import { useParams } from 'react-router-dom';

// Display a well's value: a numeric zero is a real measurement and renders as
// 0, not "N/A"; only null/undefined fall back to "N/A".
const displayWellValue = (value) => value ?? "N/A";

const PlateWell = () => {
    const channels = useChannels();
    const { plate_uuid } = useParams();
    // const [loadedUrls, setLoadedUrls] = useState({});
    const showGraph = useShowGraph();
    const graphQuery = useFetch96WellPlate2Dgraph(plate_uuid);
    const graphData = graphQuery?.isSuccess ? graphQuery.data?.signedUrl : null;
    const dropDownSelectedData = useDropDownSelectedData();

    // Define your rows and columns
    const rows = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    const cols = Array.from({ length: 12 }, (_, i) => i + 1);

    // Use a Set to keep track of selected wells
    const [selectedWells, setSelectedWells] = useState(new Set());

    // Function to toggle the selection state of a well -- future feature to add
    const toggleWell = (wellId) => {
        setSelectedWells((prevSelectedWells) => {
            const newSelected = new Set(prevSelectedWells);
            if (newSelected.has(wellId)) {
                newSelected.delete(wellId);
            } else {
                newSelected.add(wellId);
            }
            return newSelected;
        });
    };

    return (
        <div className="plate-table">
            {/* Render the column headers */}
            <div className="row-well-table header-table-well">
                <div className="cell-well header-cell text-custom-green text-[11px] font-extrabold">0</div> {/* Corner cell */}
                {cols.map((col) => (
                    <div key={col} className="cell-well header-cell text-[11px] text-custom-green font-extrabold">{col}</div>
                ))}
            </div>
            {/* Render each row */}
            {rows.map((row) => (
                <div key={row} className="row-well-table">
                    <div className="cell-well row-header font-extrabold text-[11px] text-custom-green">{row}</div> {/* Row header */}
                    {/* Render each well in the row */}
                    {cols.map((col) => {
                        // const wellId = `${row}${col}`;
                        const wellId = `${row}${col < 10 ? '0' : ''}${col}`; const wellData = dropDownSelectedData[wellId];
                        // const graph = cleanS3Url(graphData?.[wellId]);
                        const graph = graphData?.[wellId];
                        const isDualType = wellData && typeof wellData === 'object';
                        const isSelected = selectedWells.has(wellId);

                        return (
                            <div
                                key={wellId}
                                className={`cell-well well ${isSelected ? 'selected' : ''}`}
                                onClick={() => toggleWell(wellId)}
                            >
                                {/* Labels for each well */}
                                <div className="space-y-1 w-full text-[11px] font-black text-center">

                                    {isDualType ? (
                                        <>
                                            {channels.map((channel, index) =>
                                                channel?.visible ? (
                                                    <React.Fragment key={channel.name}>
                                                        {/* Render the value for the channel */}
                                                        <div className={`${cssClassForChannel(channel?.name)}`}>
                                                            {displayWellValue(wellData?.[channel?.name])}
                                                        </div>

                                                        {/* Render the graph after the first visible channel */}
                                                        {index === 0 && showGraph && graph && (
                                                            <div className="well-graph">
                                                                <img
                                                                    src={graph}
                                                                    alt="graph"
                                                                    // onLoad={() => {
                                                                    //     setLoadedUrls((prev) => ({
                                                                    //         ...prev,
                                                                    //         [wellId]: true,
                                                                    //     }));
                                                                    //     console.log(`Loaded image for ${wellId}:`, graph);
                                                                    // }}
                                                                    onError={() => {
                                                                        console.error(`Failed to load image for ${wellId}:`, graph);
                                                                        //     setLoadedUrls((prev) => ({
                                                                        //         ...prev,
                                                                        //         [wellId]: false,
                                                                        //     }));
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                ) : null
                                            )}
                                        </>

                                    ) : (
                                        <>
                                            <div className="single">
                                                {displayWellValue(wellData)}
                                            </div>
                                            {/* Render the graph only if it exists */}
                                            {showGraph && graph && (
                                                <div className="well-graph">
                                                    <img
                                                        src={graph}
                                                        alt="graph"
                                                        // onLoad={() => {
                                                        //     setLoadedUrls((prev) => ({
                                                        //         ...prev,
                                                        //         [wellId]: true,
                                                        //     }));
                                                        //     console.log(`Loaded image for ${wellId}:`, graph);
                                                        // }}
                                                        onError={() => {
                                                            console.error(`Failed to load image for ${wellId}:`, graph);
                                                            // setLoadedUrls((prev) => ({
                                                            //     ...prev,
                                                            //     [wellId]: false,
                                                            // }));
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </>

                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default PlateWell;
